const PageLoader = () => (
  <div className="min-h-[40vh] flex items-center justify-center">
    <div className="loader" />
  </div>
);

export default PageLoader;
